module.exports = __webpack_public_path__ + "static/img/ios_hi.7fe38b60.png";